
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Component Libraries`}</h3>
    <ul>
      <li parentName="ul">{`Added new components to our `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/angular"
        }}>{`Angular`}</a>{` and `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/react-native"
        }}>{`React Native`}</a>{` component libraries:`}
        <ul parentName="li">
          <li parentName="ul">{`For Angular, we now have components for `}<a parentName="li" {...{
              "href": "https://pxblue-components.github.io/angular/?path=/info/components-drawer--readme"
            }}>{`Drawer`}</a>{`, `}<a parentName="li" {...{
              "href": "https://pxblue-components.github.io/angular/?path=/info/components-list-item-tag--readme"
            }}>{`ListItemTag`}</a>{`, `}<a parentName="li" {...{
              "href": "https://pxblue-components.github.io/angular/?path=/info/components-spacer--readme"
            }}>{`Spacer`}</a>{`,
`}<a parentName="li" {...{
              "href": "https://pxblue-components.github.io/angular/?path=/info/components-score-card--readme"
            }}>{`Scorecard`}</a>{`, and `}<a parentName="li" {...{
              "href": "https://pxblue-components.github.io/angular/?path=/info/components-info-list-item--readme"
            }}>{`InfoListItem`}</a>{`.`}</li>
          <li parentName="ul">{`For React Native, we now have a `}<a parentName="li" {...{
              "href": "https://pxblue-components.github.io/react-native/?path=/info/components-documentation--drawer"
            }}>{`Drawer`}</a>{` component.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Enhanced style override capabilities on all of our React and React Native components`}</li>
      <li parentName="ul">{`Adopted `}<a parentName="li" {...{
          "href": "https://callstack.github.io/react-native-paper/"
        }}>{`React Native Paper`}</a>{` as our official Material component library for React Native projects`}</li>
    </ul>
    <h3>{`Reusable Workflows`}</h3>
    <p>{`We're excited to announce the availability of our first re-usable workflow: a reusable `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@pxblue/react-native-auth-workflow"
      }}>{`Authentication Workflow`}</a>{` for React Native apps. This workflow allows teams to use a common implementation for login & registration across different projects (just hook it up to your API).`}</p>
    <h3>{`Design Patterns`}</h3>
    <ul>
      <li parentName="ul">{`Migrated React design patterns into a `}<a parentName="li" {...{
          "href": "https://codesandbox.io/s/github/pxblue/react-design-patterns"
        }}>{`single repository`}</a>{`.`}</li>
      <li parentName="ul">{`Angular, React Native, and Ionic design patterns will be migrated in an upcoming release.`}</li>
    </ul>
    <h3>{`PX Blue CLI`}</h3>
    <p>{`The first version of the `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@pxblue/cli"
      }}>{`PX Blue CLI`}</a>{` is now available. This tool allows you to generate new Angular, Ionic, React, or React Native projects pre-loaded with PX Blue components and themes, with no manual configuration required.`}</p>
    <h3>{`Miscellaneous`}</h3>
    <ul>
      <li parentName="ul">{`Added search capability to documentation site`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/community/file/852558784352181868"
        }}>{`Sticker Sheet`}</a>{` published to the Figma Community`}</li>
      <li parentName="ul">{`Bug fixes and improvements`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;